import { ReactNode } from 'react';
import React from 'react';

import { ReactComponent as Plus } from '../../assets/icons/plus.svg';

import { CloseButton, ModalContainer, Overlay, Title, Top } from './styled';

const Modal = ({
	open,
	handleClose,
	title,
	children,
}: {
	open: boolean;
	handleClose: () => void;
	title: string;
	children?: ReactNode;
}) => {
	if (!open) return null;

	return (
		<Overlay onClick={(event) => event.target === event.currentTarget && handleClose()}>
			<ModalContainer>
				<Top>
					<Title>{title}</Title>
					<CloseButton onClick={handleClose} aria-label="Close contact form">
						<Plus className="close" />
					</CloseButton>
				</Top>
				{children}
			</ModalContainer>
		</Overlay>
	);
};

export default Modal;
